import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton, Typography, useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { DEFAULT_BORDER } from 'src/constants';
import { InvoicePaymentHistoryLog } from 'src/utils/tableUtils';

interface PaymentHistoryTableProps {
    currency: string;
    paymentLogs: InvoicePaymentHistoryLog[];
    onPaymentToDelete: (payment: InvoicePaymentHistoryLog) => void;
}

const PaymentHistoryTable = ({
    currency,
    paymentLogs,
    onPaymentToDelete,
}: PaymentHistoryTableProps) => {
    const theme = useTheme();

    return (
        <TableContainer component={Paper}>
            <Table sx={{ ...DEFAULT_BORDER }} aria-label="payment history table">
                <TableHead>
                    <TableRow sx={{ bgcolor: theme.palette.common.orange }}>
                        {(() => {
                            const headers = [
                                'Payment Date',
                                'Payment Method',
                                'Payment Amount',
                                '',
                            ];
                            return headers.map((header) => {
                                return (
                                    <th key={header}>
                                        <Typography
                                            textAlign="start"
                                            p="16px"
                                            color={theme.palette.text.primary}
                                        >
                                            {header}
                                        </Typography>
                                    </th>
                                );
                            });
                        })()}
                    </TableRow>
                </TableHead>
                <TableBody data-testid="payment-history-body">
                    {paymentLogs.map((row, index) => {
                        return (
                            <TableRow
                                key={`${index}-${row.paymentDate}`}
                                sx={{
                                    bgcolor:
                                        index % 2 !== 0
                                            ? theme.palette.common.orange
                                            : theme.palette.background.default,
                                }}
                            >
                                {(() => {
                                    const rowData = [
                                        row.paymentDate,
                                        row.paymentMethod,
                                        `${currency}${row.paymentAmount.toFixed(2)}`,
                                    ];
                                    return rowData.map((row, index) => {
                                        return (
                                            <td key={index}>
                                                <Typography
                                                    textAlign="start"
                                                    p="16px"
                                                    color={theme.palette.text.primary}
                                                >
                                                    {row}
                                                </Typography>
                                            </td>
                                        );
                                    });
                                })()}
                                <td key={index}>
                                    <IconButton
                                        onClick={() => {
                                            return onPaymentToDelete(row);
                                        }}
                                    >
                                        <DeleteOutlineIcon />
                                    </IconButton>
                                </td>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default PaymentHistoryTable;
